import { api, unwrap } from '@/lib/api/client'

export interface CurrentUser {
  id: number | string
  card_id: string
  /** รหัสประจำตัวผู้สมัคร (A+ปีพ.ศ.+id) — ใช้อ้างอิงแทนเลขบัตร (migration 010) */
  applicant_code?: string | null
  fname: string
  lname: string
  type: 'user' | 'admin'
  role?: string
  [k: string]: unknown
}

export function login(input: { card_id: string; pass: string }) {
  const body = new URLSearchParams({
    card_id: input.card_id,
    pass: input.pass,
  })
  return unwrap<CurrentUser>(
    api.post('/auth/login', body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
  )
}

export function logout() {
  return unwrap<{ logged_out: boolean }>(api.post('/auth/logout'))
}

export function me() {
  return unwrap<CurrentUser>(api.get('/me'))
}
